import { data } from "azure-maps-control";
import { VisitNodePassage } from "../../../types";
import { createTooltipItems } from "../tooltips/highchartTooltip";
import { esgScores, quartileScores } from "common/esg-helpers";
const getAllValues = (nodes, field) => {
    let values = [];
    for (const node of nodes) {
        if (node.data) {
            values = values.concat(getAllValues(node.data, field));
        }
        if (node.measures && node.measures[field]) {
            values.push(node.measures[field]?.toString() || "");
        }
    }
    return values;
};
const init = (params, context) => {
    if (!context.staticData.customResult?.length) {
        const colorSet = context.componentProps?.colorSet || "";
        let legend = [...new Set(getAllValues(context.staticData.root, params.legend))];
        if (colorSet === "esg") {
            const scores = esgScores.map((value, index) => ({ index, value })).filter((s) => legend.includes(s.value));
            legend = [];
            for (const score of scores) {
                legend[score.index] = score.value;
            }
        }
        if (colorSet === "quartile") {
            const scores = quartileScores.map((value, index) => ({ index, value })).filter((s) => legend.includes(s.value));
            legend = [];
            for (const score of scores) {
                legend[score.index] = score.value;
            }
        }
        context.staticData.customResult = [
            {
                colorSet,
                items: [],
                legend
            }
        ];
    }
};
const getIndex = (colorSet, legend, legendItems) => {
    switch (colorSet) {
        case "quartile":
            return quartileScores.indexOf(legend);
        case "esg":
            return esgScores.indexOf(legend);
        default:
            return legendItems.indexOf(legend);
    }
};
const addMapItem = (params, element, result) => {
    const lat = element.measures?.[params.latitude], legend = element.measures?.[params.legend], legendItems = result.legend || [], lon = element.measures?.[params.longitude];
    if (lat && lon) {
        const index = getIndex(result.colorSet, legend, legendItems);
        result.items.push(new data.Feature(new data.Point([Number.isFinite(lon) ? Number(lon) : 0, Number.isFinite(lat) ? Number(lat) : 0]), {
            customElements: createTooltipItems(params.tooltip, element.measures),
            legend,
            markerIndex: index,
            tooltip: ""
        }));
    }
    else {
        result.filteredAssetCount = (result.filteredAssetCount || 0) + 1;
    }
};
const unclusterData = (points) => {
    const delta = 0.001, east = { lat: 0, lon: delta }, north = { lat: delta, lon: 0 }, south = { lat: -delta, lon: 0 }, west = { lat: 0, lon: -delta };
    const deltaPositions = [north, west, south, east], deltaPositionsIndces = {};
    points.forEach((m) => {
        if (m.coordinates[1] && m.coordinates[0]) {
            if (!deltaPositionsIndces[m.coordinates[1]]) {
                deltaPositionsIndces[m.coordinates[1]] = {};
            }
            if (deltaPositionsIndces[m.coordinates[1]][m.coordinates[0]]) {
                const clusterSiblingPosIndex = deltaPositionsIndces[m.coordinates[1]][m.coordinates[0]];
                clusterSiblingPosIndex.position = (clusterSiblingPosIndex.position + 1) % deltaPositions.length;
                if (clusterSiblingPosIndex.position === 0) {
                    clusterSiblingPosIndex.multiple += 1;
                }
                m.coordinates[1] += clusterSiblingPosIndex.multiple * deltaPositions[clusterSiblingPosIndex.position].lat;
                m.coordinates[0] += clusterSiblingPosIndex.multiple * deltaPositions[clusterSiblingPosIndex.position].lon;
            }
            else {
                deltaPositionsIndces[m.coordinates[1]][m.coordinates[0]] = { multiple: 0, position: -1 };
            }
        }
    });
};
export const map = (params) => (args) => {
    if (args.context.visitNodePassage === VisitNodePassage.NodeFirst && args.visitable) {
        init(params, args.context);
    }
    const [result] = args.context.staticData.customResult || [];
    if (args.context.visitNodePassage === VisitNodePassage.Leaf && args.visitable && result) {
        addMapItem(params, args.visitable, result);
    }
    if (args.context.visitNodePassage === VisitNodePassage.RootLast && result) {
        unclusterData(result.items.map((x) => x.geometry));
    }
};
